export const toErrorMessageWithCode = (message, error) => {
  const errorCode = error?.code
  const errorCodeMsg = errorCode ? `(${errorCode})` : ''
  return [message, errorCodeMsg].join(' ')
}

export default null
